import { render } from "./ExampleDeviceScreenVcard.vue?vue&type=template&id=610bc593&scoped=true&ts=true&lang=pug"
import script from "./ExampleDeviceScreenVcard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExampleDeviceScreenVcard.vue?vue&type=script&lang=ts&setup=true"

import "./ExampleDeviceScreenVcard.vue?vue&type=style&index=0&id=610bc593&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610bc593"]])

export default __exports__